import React, { memo } from "react";
// import Colors from "../Color";
import { Constants } from "../../../constants";

function BadgePoint({ points, color = Constants.colors.main, position = "absolute" }) {

  return points ? (
    <div
      style={{
        position,
        top: 8,
        left: 8,
        backgroundColor: color,
        paddingLeft: 8,
        paddingRight: 8,
        paddingTop: 4,
        paddingBottom: 4,
        borderRadius: 20,
        zIndex: 3,
        boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
        borderWidth: 1,
        borderStyle: "solid",
        borderColor: color,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
        {/* <FontAwesomeIcon icon={faStar} color={Colors.white} size={12} /> */}
        <span
          style={{
            color: color === Constants.colors.white ? Constants.colors.main : Constants.colors.white,
            fontSize: 12,
            fontWeight: "bold"
          }}
        >
          Gagnez {points || 0}% de points
        </span>
      </div>
    </div>
  ) : null;
}

export default memo(BadgePoint);
